module.exports = __webpack_public_path__ + "static/media/9.f83d575f.jpg";